import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "seq-ovi-advisory" }
const _hoisted_2 = { class: "carousel-inner" }
const _hoisted_3 = { class: "p-0 m-0 carousel-indicators carousel-indicators-dots seq-ovi-advisory__indicators" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible = $event)),
    title: "Advisory",
    width: "720px",
    class: "seq-ovi-advisory-dialog",
    "align-center": "",
    "destroy-on-close": "",
    onClosed: _ctx.onClosed
  }, {
    footer: _withCtx(() => [
      _createVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, " Close ")
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        (_openBlock(), _createBlock("div", {
          key: _ctx.isMobile ? 'mobile' : 'desktop',
          id: "ovi_advisory_carousel",
          class: "carousel carousel-custom slide w-100",
          "data-bs-ride": "carousel",
          "data-bs-interval": "5000"
        }, [
          _createVNode("div", _hoisted_2, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
              return (_openBlock(), _createBlock("div", {
                key: slide.src,
                class: ["carousel-item", { active: index === 0 }]
              }, [
                _createVNode("img", {
                  src: slide.src,
                  alt: slide.alt,
                  class: "seq-ovi-advisory__img"
                }, null, 8, ["src", "alt"])
              ], 2))
            }), 128))
          ]),
          _createVNode("ol", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
              return (_openBlock(), _createBlock("li", {
                key: 'dot-' + slide.src,
                "data-bs-target": "#ovi_advisory_carousel",
                "data-bs-slide-to": index,
                class: { active: index === 0, 'ms-1': index > 0 }
              }, null, 10, ["data-bs-slide-to"]))
            }), 128))
          ])
        ]))
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onClosed"]))
}